<template>
  <div
    ref="toast"
    class="app-toast"
    :class="[state]"
    @transitionend="transitionEnded"
  >
    <div v-if="message.icon" class="toast-icon">
      <app-icon :name="message.icon"></app-icon>
    </div>
    <div class="toast-content">
      <slot>
        <div class="toast-body" v-html="message.body"></div>
      </slot>
      <div class="toast-time">
        {{ $t('date.ago', { time: since }) }}
      </div>
    </div>
    <div class="close-btn" @click="close"></div>
  </div>
</template>

<script>
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import frLocale from 'date-fns/locale/fr'
import appIcon from './app-icon'

export default {
  name: 'AppToast',

  components: {
    'app-icon': appIcon
  },
  props: {
    message: Object
  },

  data() {
    return {
      state: 'initial'
    }
  },

  computed: {
    since({ message }) {
      return distanceInWordsToNow(message.timestamp, {
        locale: frLocale
      })
    }
  },

  mounted() {
    const { timeout } = this.message
    requestAnimationFrame(() => {
      this.state = 'opened'
    })

    if (timeout) {
      setTimeout(() => {
        this.state = 'closed'
      }, timeout)
    }
  },

  methods: {
    close() {
      this.state = 'closed'
    },

    transitionEnded({ target }) {
      const { state } = this
      if (state === 'closed' && target === this.$refs.toast) {
        this.$store.dispatch('toasts/removeMessage', {
          id: this.message.id
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.app-toast {
  position: relative;
  pointer-events: auto;
  display: flex;
  width: 30rem;
  min-height: 10rem;
  padding: 2rem;
  border-radius: 4px;
  background-color: white;
  box-shadow: 0px 1px 6px 0 rgba(0, 0, 0, 0.15);
  transition: opacity 400ms;
  opacity: 0;

  &.opened {
    opacity: 1;
  }
}

.toast-icon {
  display: flex;
  align-items: center;
  border-right: 1px solid $color-diamond;
  padding-right: 1.6rem;

  .app-icon {
    width: 3.2rem;
    height: auto;
  }
}

.toast-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-left: 1.6rem;
}

.toast-body {
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.57;
}

.toast-time {
  margin-top: auto;
  margin-bottom: 0;
  font-size: 1.2rem;
  color: $color-daddy;
}

.close-btn {
  cursor: pointer;
  position: absolute;
  top: 1.2rem;
  right: 0.8rem;
  width: 1rem;
  height: 1rem;
  background-image: url('~@/assets/icn-close-gray-medium.svg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
